import { Stack } from '@koob/margaret';
import { useTranslation } from 'react-i18next';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { KoobButton, KoobInputTextareaField } from '@koob/ui';

const RefuseAdminBookingForm = ({ onSubmit, onClose }) => {
  const { t } = useTranslation('bookings');

  return (
    <Formik
      initialValues={{ hotelKeeperMessage: '' }}
      validationSchema={Yup.object().shape({
        hotelKeeperMessage: Yup.string().required(t('errors:required')),
      })}
      enableReinitialize
      onSubmit={onSubmit}
    >
      {({ isSubmitting }) => (
        <Form>
          <Stack size="full" direction="column" paddingTop={1} gutterSize={2}>
            <KoobInputTextareaField
              name="hotelKeeperMessage"
              label={t('reason')}
              required
              data-testid="refuse-booking-form-textarea"
            />
            <Stack size="full" alignX="flex-end" gutterSize={1}>
              <KoobButton type="button" variant="secondary" onClick={onClose}>
                {t('misc:cancel')}
              </KoobButton>
              <KoobButton
                variant="danger"
                loading={isSubmitting}
                type="submit"
                testId="refuse-booking-form-button"
              >
                {t('hotelKeeper:submit.refuse')}
              </KoobButton>
            </Stack>
          </Stack>
        </Form>
      )}
    </Formik>
  );
};

export default RefuseAdminBookingForm;
